





































































import {
  SimilarityAnalysisItem,
  SimilarityFaultCaseType,
} from '@/interfaces/types/AnalysisResult';
import Vue, { PropType } from 'vue';
import CheckBox from '../common/CheckBox/CheckBox.vue';
import Button from '../common/Button/Button.vue';
import SimilarityResultListItem from './SimilarityResultListItem.vue';
import SimilarityFileFrequencyListItem from './SimilarityFileFrequencyListItem.vue';
import HintButton from '../common/Button/HintButton.vue';

export default Vue.extend({
  props: {
    analysisItem: {
      type: Object as PropType<SimilarityAnalysisItem>,
      required: false,
    },
  },
  components: {
    CheckBox,
    Button,
    HintButton,
    SimilarityResultListItem,
    SimilarityFileFrequencyListItem,
  },
  data(): {
    showErrorList: boolean;
    showWarningList: boolean;
    isCaseListMode: boolean;
  } {
    return {
      showErrorList: true,
      showWarningList: true,
      isCaseListMode: true,
    };
  },
  computed: {
    /**
     * Concat error list & warning list
     */
    totalDataList(): { data: SimilarityFaultCaseType; type: string }[] {
      if (this.hasAnalysisItem) {
        const errorList = this.showErrorList
          ? this.analysisItem.error_list.map((i) => {
              return { data: i, type: 'error' };
            })
          : [];
        const warningList = this.showWarningList
          ? this.analysisItem.warning_list.map((i) => {
              return { data: i, type: 'warning' };
            })
          : [];

        return errorList.concat(warningList);
      } else return [];
    },
    hasAnalysisItem(): boolean {
      return this.analysisItem && Object.keys(this.analysisItem).length !== 0;
    },
  },
  methods: {
    toggleListMode() {
      this.isCaseListMode = !this.isCaseListMode;
    },
  },
});
